import React, { Suspense, lazy } from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import Logout from 'features/auth/components/Logout';
import TextLoader from '../components/TextLoader';
import PrivateRoute from './PrivateRoute';
import { LOGOUT } from './PageUrls';

const Main = lazy(() => import('./InnerRouter'));

const Router = () => (
  <BrowserRouter>
    <Suspense
      fallback={
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: '100vh' }}
        >
          <TextLoader text="LOADING..." size="large" />
        </div>
      }
    >
      <Routes>
        <Route path={LOGOUT} element={<Logout />} />
        <Route
          path="/*"
          element={<PrivateRoute path="/*" component={Main} />}
        />
      </Routes>
    </Suspense>
  </BrowserRouter>
);

export default Router;
